import * as React from 'react'

import { Site } from '../../../../common/constants/siteList'
import { ILocationParams } from '../../../../common/reducers/reactRouterLocation'
import { toTitle } from '../../../../common/utils/formatString'
import CrossPromoBanner from '../../../shared/components/crossPromoBanner'
import FilterPanel from './filterExpandPanel/panelContainer'
import FilterGroupPanel from './filterGroup/groupPanelContainer'

interface IProps {
  locationParams: ILocationParams
  activeFilters: any[]
  currentSite: Site
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
}

const SearchFilters = ({
  locationParams,
  activeFilters = [],
  currentSite,
  makeSearchLink
}: IProps) => {
  const currentCategory = locationParams.category

  return (
    <div data-test-selector="search-filters">
      <FilterGroupPanel id="filterGroup">
        {activeFilters.map((filter, index, list) => {
          return (
            <FilterPanel
              title={filter.title || toTitle(filter.id)}
              id={filter.id}
              key={filter.id}
            >
              <filter.Component
                key={index}
                locationParams={locationParams}
                makeSearchLink={makeSearchLink}
                {...filter.props}
              />
            </FilterPanel>
          )
        })}
        <CrossPromoBanner
          currentSite={currentSite}
          currentCategory={currentCategory}
        />
      </FilterGroupPanel>
    </div>
  )
}

export default SearchFilters
